module.exports = __webpack_public_path__ + "static/img/fun.f2794d7b.png";